import { apiRequest } from '../../services/index.js';
import { getDashboard } from '../reducers/getDashboardReducer.js';
import * as env from '../../config/env.js';

// Actions
export const getDashboardDetail = (id) => async dispatch => {
    try {
        await apiRequest("get", `${env.GETDASHBOARD}/${id}`).then((response) => {
            if(response.status === 200){
                dispatch(getDashboard(response.data.data));
            }
        }).catch((error) => {
            console.error('Get user Action Error',error);
        });
    } catch (e) {
        console.error('user get Error Action',e.message);
    }
};